import { connect } from 'react-redux';
import LastPlayedSongs from '../components/LastPlayedSongs';
import { fetchLastPlayedSongsIfNeeded, addLastPlayedSongIfNeeded } from '../actions/LastPlayedSongsAction';
import { showSpotModal } from '../../spot/actions/spotActions';

const mapStateToProps = (state) => ({
    lastPlayedSongs: state.aovivo.lastPlayedSongs.lastPlayedSongs,
    time: state.aovivoBar.NowPlaying.musicLive.time,
    currentMetaId: state.aovivoBar.MediaPlayer.currentStream.metaId,
});
const mapDispatchToProps = (dispatch) => ({
    fetchLastPlayedSongsIfNeeded: () => {
        dispatch(fetchLastPlayedSongsIfNeeded());
    },
    addLastPlayedSongIfNeeded: () => {
        dispatch(addLastPlayedSongIfNeeded());
    },
    showSpotModal: (spotSlug) => {
        dispatch(showSpotModal(spotSlug));
    },
});
const LastPlayedSongsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(LastPlayedSongs);

export default LastPlayedSongsContainer;
